import apiCurrency from '@/api/currency'
export default [
  {
    path: '/currencies',
    name: 'currency',
    meta: { requiresAuth: true },
    component: () => import('@/pages/currency/index.vue')
  },
  {
    path: '/currencies/:id',
    name: 'currency-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/currency/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      let response = await apiCurrency.find(to.params.id)
      to.params.editData = response.data
      next()
    }
  }
]
